// extracted by mini-css-extract-plugin
export default {"LockImage":"LockImage_LockImage__aYd3f","LockImage__img":"LockImage_LockImage__img__D2mzQ","spin":"LockImage_spin__AXmci"};